/*
 * Build-a-box (Build Your Own Bundle) logic.
 * Ported from Main Theme assets/custom.js, which bundled jQuery 3.7.1 inline.
 * jQuery is loaded separately from CDN in sections/build-your-own.liquid.
 */

$(document).ready(function () {
  $(document).on("click", ".coll_item", function () {
    var $el = $(this),
      target = $el.attr("data-target");
    $(".coll_item").removeClass("active");
    $el.addClass("active");
    $(".bab_product__item").hide();
    $("." + target).show();
  });
  $('[data-target="coll__all"]').click();

  $(document).on("click", ".addtobundle_btn", function () {
    var $el = $(this),
      $wrap = $el.closest(".bab_add_actions"),
      $select = $wrap.find(".variant_pick"),
      prd_data = JSON.parse($select.attr("data-prd_data"));
    update_bab_atc(prd_data?.image, $select.val());
  });

  $(document).on("click", ".bab_picker_item .remove-btn", function (e) {
    e.stopPropagation();
    var $el = $(this),
      $wrap = $el.closest(".bab_picker_item"),
      i = $wrap.attr("data-index"),
      $wrapp = $(`.bab_picker_item[data-index="${i}"]`),
      $selectedPicker = $wrapp.find(".selected_picker"),
      s = $selectedPicker.attr("data-index");
    console.log(i, "<<<<indedded");
    $selectedPicker.hide();
    $selectedPicker.find("img").remove();
    $selectedPicker.find(".remove-btn").remove();
    // adjustPositions();
  });

  $(document).on("click", ".checkout_bab", function () {
    var $el = $(this),
      items = [],
      d = new Date();
    timespna = d.getTime();
    $(".bab_header_section .bab_picker_items .bab_picker_item").each(
      function () {
        let $img = $(this).find(".selected-image");
        if ($img?.length) {
          items.push({
            id: $img.attr("data-id"),
            quantity: 1,
            properties: { __souce: "buildabox", __conected_id: timespna },
          });
        }
      }
    );
    console.log(items, "<<<");
    let acI = $(`.bab_picker_item[data-index="${items.length}"]`)
        .find(".piker_title")
        .attr("data-discount"),
      goto = $(".buildabox-secion").attr("data-goto");
    let redirectURL =
      goto == "checkout"
        ? `/checkout?discount=${acI}`
        : goto == "cart"
        ? `/cart?discount=${acI}`
        : null;
    $(".upcart-checkout-button").attr("href", `/checkout?discount=${acI}`);
    if (items.length) {
      multipleATC(items, redirectURL);
    } else {
      alert("Please! select one or more items");
    }
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop(),
      s = $(".bab_header_section").offset().top,
      h = $(".bab_header_section").height(),
      x = parseFloat(h) + parseFloat(s) + 30;
    console.log(scroll, s, h, x, "<<<");
    if (scroll >= x) {
      $(".build-a-box--section").addClass("stickyy");
    } else {
      $(".build-a-box--section").removeClass("stickyy");
    }
  });
}); //ready

function update_bab_atc(image_url = "", id = null) {
  setTimeout(function () {
    $(".bab_picker_items").each(function () {
      $(this)
        .find(".bab_picker_item")
        .each(function () {
          const $item = $(this);
          const $selectedPicker = $item.find(".selected_picker");

          if ($selectedPicker.find(".remove-btn").length === 0) {
            $selectedPicker.append(
              `<button class="remove-btn"><svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt">
                  <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path>
                </svg></button>`
            );
          }

          if ($selectedPicker.find("img").length === 0) {
            $selectedPicker.append(
              `<img src="${image_url}" alt="Selected Image" class="selected-image" data-id="${id}">`
            );
            $selectedPicker.show();
            return false;
          }
        });
    });
  }, 0);
}

function adjustPositions() {
  const items = $(".bab_picker_items .bab_picker_item");
  items.each(function (index) {
    $(this).attr("data-index", index + 1);
  });
}

function multipleATC(data, redirectURL = null) {
  var items = [];
  console.log(data);
  data.forEach(function (item) {
    items.push({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    });
  });

  let formData = {
    items: items,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        if (redirectURL) {
          window.location.href = redirectURL;
        } else {
          setTimeout(function () {
            // window.refreshCart();
            document.querySelector("#cart-icon-bubble").click();
          }, 0);
          // window.location.href = "/cart";
        }
      }
      return response.json();
    })
    .then((items) => {
      console.log(items);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

var removeItems = (productIDS) => {
  console.log(productIDS, "<<<<call removeItems");
  if (productIDS.length) {
    let formData = {
      updates: {},
    };

    var productID;
    for (productID in productIDS) {
      var id = productIDS[productID]?.split("|")[0];
      var qty = productIDS[productID]?.split("|")[1];
      formData["updates"][parseInt(id)] = qty;
    }
    console.log(formData);

    let info = fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        // window.refreshCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};
